/**
 * @file NotFoundFilters.tsx
 * @description Строка фильтров журнала «Не найдено» (phase19.16, партия
 * «SEO-техника», v0.19.65; SB148; uiux-seo-tech §3.1): поиск по адресу,
 * период «Сегодня · 7 дней · 30 дней» (`FilterChips`), «Обработанные и
 * скрытые (N)» (`FilterToggleChips`) и, до 1024, «Порядок: … ⌄» —
 * `OptionSheet` (на 1280 порядок — кнопками в шапке таблицы). На 360 поиск
 * и пилюли — в две строки, ряд пилюль переносится (SC45); с 768 — одной
 * строкой.
 */

import { NOT_FOUND_PERIOD_LABELS, NOT_FOUND_PERIODS, NOT_FOUND_SORTS, type NotFoundPeriod, type NotFoundSort } from "@chaiberi/shared";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

import { Button } from "../../ui/button";
import { FilterChips, FilterToggleChips } from "../../ui/FilterChips";
import { OptionSheet } from "../../ui/OptionSheet";
import { SearchInput } from "../../ui/SearchInput";
import type { NotFoundApi } from "../../../hooks/site-seo/useNotFound";
import { BELOW_LG_QUERY, useMediaQuery } from "../../../hooks/useMediaQuery";
import { NOT_FOUND_SORT_LABELS } from "../../../lib/site-seo/not-found-view";

export function NotFoundFilters({ api }: { api: NotFoundApi }) {
  const narrow = useMediaQuery(BELOW_LG_QUERY);
  const [sortOpen, setSortOpen] = useState(false);
  const handled = api.journal?.handledCount;
  return (
    <div className="flex min-w-0 flex-col gap-3 md:flex-row md:flex-wrap md:items-center">
      <SearchInput value={api.query} onChange={api.setQuery} placeholder="Найти адрес…" ariaLabel="Найти адрес в журнале" className="md:max-w-72" />
      <FilterChips<NotFoundPeriod>
        aria-label="Период"
        value={api.period}
        onChange={api.setPeriod}
        items={NOT_FOUND_PERIODS.map((p) => ({ value: p, label: NOT_FOUND_PERIOD_LABELS[p] }))}
      />
      <FilterToggleChips
        aria-label="Обработанные и скрытые адреса"
        items={[{ key: "handled", label: "Обработанные и скрытые", count: handled, pressed: api.all, onToggle: () => api.setAll(!api.all) }]}
      />
      {narrow ? (
        <>
          <Button variant="ghost" className="self-start" onClick={() => setSortOpen(true)}>
            Порядок: {NOT_FOUND_SORT_LABELS[api.sort]}
            <ChevronDown aria-hidden />
          </Button>
          <OptionSheet
            open={sortOpen}
            onOpenChange={setSortOpen}
            title="Порядок"
            value={api.sort}
            options={NOT_FOUND_SORTS.map((s) => ({ value: s, label: NOT_FOUND_SORT_LABELS[s] }))}
            onChange={(value) => api.setSort(value as NotFoundSort)}
          />
        </>
      ) : null}
    </div>
  );
}
